import styles from './Artwork.module.css'

export default function Artwork(props) {
  return(
    <div onClick={props.openZoom} className={styles.wrapper} data-imageurl={props.submission.image_url}>
      <img src={props.submission.image_url} />
    </div>
  )
}